import { Injectable } from '@angular/core';
import { Router, Routes } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CurrentRouteService {

  constructor(
    private router: Router,
  ) { }

  isCurrentRouteExistIn(routes: Routes): boolean {
    const currentRoute = this.router.url.split('/');
    currentRoute.shift();
    const publicPaths = routes.map(route => route.path ? route.path.split('/') : []);

    const isPublicRoute = publicPaths.some(route => {
      return route.length > 0 && route.every((path, index) => {
        return path === currentRoute[index] || path.startsWith(':');
      });
    });

    return isPublicRoute;
  }
}
